import { Box, Typography, Paper, Button } from "@mui/material";
import React from "react";

const QRCode = ({ qrCode, startConnection }) => {
    return (
        <Box
            sx={{
                height: "100%",
                width: "100%",

                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    height: 430,
                    width: 430,
                    borderRadius: 4,
                    padding: 2,
                    backdropFilter: "blur(10px)",
                }}
            >
                {/* Title */}
                <Box
                    sx={{
                        paddingBottom: 2,
                        borderBottom: "1px solid #1F2937",
                        textAlign: "center",
                    }}
                >
                    <Typography variant="h5" fontWeight="bold">
                        Login via QR Code
                    </Typography>
                </Box>

                {/* Subtitle */}
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ marginTop: 2, textAlign: "center" }}
                >
                    Open QR code scanner in WhatsApp and scan.
                </Typography>

                {/* QR Code Box */}
                <Box
                    sx={{
                        height: 200,
                        width: 200,
                        margin: "28px auto",
                        border: "2px solid black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {qrCode ? (
                        <img
                            src={qrCode}
                            alt="QR Code"
                            style={{ width: "100%", height: "100%" }}
                        />
                    ) : (
                        <Typography>Waiting for QR code...</Typography>
                    )}
                </Box>

                {/* <Button fullWidth variant="contained" onClick={startConnection}>
                    Start Connection
                </Button> */}
            </Paper>
        </Box>
    );
};

export default QRCode;
